<div class="upsell-cta">
  <div class="upsell-cta__container mx-auto leading-tight	">
    <button 
      data-qa="cta-yes" 
      class="upsell-cta__button-yes bg-hartfelt-red min-h-12 max-w-96 px-4 w-full rounded-full mb-3 mt-8"
      (click)="nextPage(true)"  
      data-te="cta-yes" 
      [innerHTML]="buttonYesText"  
    >
    </button>

    <button 
      data-qa="cta-no" 
      class="upsell-cta__button-no bg-stone-300 min-h-12 max-w-96 px-4 w-full rounded-full"
      (click)="nextPage(false)" 
      [innerHTML]="buttonNoText" 
      data-te="cta-no">
    </button>
  </div>
</div>
